import { useMemo, useState } from "react";
import BanerDashboard from "../Dashboard/BanerDashboard/BanerDarshboard";
import BrandLogOutBox from "./BrandLogOutBox";
import BrandSideMenu from "./BrandSideMenu";

function FieldRow({ label, value, valueDir = "rtl" }) {
  return (
    <div className="flex flex-row items-center justify-between bg-white rounded-lg px-4 py-3 border border-slate-200">
      <p className="text-slate-500 text-sm text-right">{label}</p>
      <p
        dir={valueDir}
        className="t-grayDark text-sm font-semibold text-left break-words max-w-[60%]"
      >
        {value || "—"}
      </p>
    </div>
  );
}

function BrandingPage() {
  const [activeTab, setActiveTab] = useState(0);
  const [showLogOut, setShowLogOut] = useState(false);

  const brand = useMemo(
    () => ({
      name: "برند نمونه",
      description:
        "این بخش فعلاً صرفاً نمایشی است و بعداً با API تکمیل می‌شود.",
      logoUrl: "/image/Logo.png",
    }),
    []
  );

  const companyInfo = useMemo(
    () => ({
      legalName: "شرکت نمونه نوآوران (سهامی خاص)",
      nationalIdOrRegNo: "۱۴۰۰۱۲۳۴۵۶۷ / ۱۲۳۴۵۶",
      industry: "هوش مصنوعی",
      website: "https://example.com",
      companySize: "۱۱ تا ۵۰ نفر",
    }),
    []
  );

  const contactPerson = useMemo(
    () => ({
      fullName: "علی رضایی",
      jobTitle: "مدیر فنی (CTO)",
      businessEmail: "admin@example.com",
      mobile: "0912XXXXXXX",
    }),
    []
  );

  return (
    <>
      <div className="bg-purpleLight w-full h-full flex flex-row-reverse pb-10">
        <BrandSideMenu
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          openModal={setShowLogOut}
        />

        <div className="w-5/6 h-screen bg-white flex flex-col shadow rounded-r-2xl my-2 ml-2 pb-4">
          <BanerDashboard text="داشبورد برند" />

          <div className="flex-1 flex flex-row-reverse items-start justify-start p-6 overflow-auto">
            <div className="w-full max-w-3xl space-y-6" dir="rtl">
              <div className="w-full bg-garyLight rounded-2xl shadow p-6">
                <div className="flex flex-row items-center">
                  <div className="bg-white rounded-2xl shadow p-3">
                    <img
                      src={brand.logoUrl}
                      alt={brand.name}
                      className="w-20 h-20 object-contain"
                    />
                  </div>
                  <div className="flex flex-col items-end mr-4">
                    <h2 className="t-purpleDark text-2xl font-black">
                      {brand.name}
                    </h2>
                    <p className="text-slate-500 text-sm mt-2">اطلاعات برند</p>
                  </div>
                </div>

                <div className="mt-6">
                  <p className="text-slate-600 text-sm leading-8 text-right">
                    {brand.description}
                  </p>
                </div>
              </div>

              <div className="w-full bg-garyLight rounded-2xl shadow p-6">
                <div className="flex flex-col">
                  <h3 className="t-purpleDark text-lg font-extrabold">
                    اطلاعات پایه و هویتی شرکت
                  </h3>
                  <p className="text-slate-500 text-xs mt-2 text-right leading-6">
                    این بخش برای شناخت مشتری و اعتبارسنجی اولیه است.
                  </p>
                </div>

                <div className="mt-4 grid grid-cols-1 gap-3">
                  <FieldRow
                    label="نام رسمی شرکت"
                    value={companyInfo.legalName}
                  />
                  <FieldRow
                    label="شناسه ملی / شماره ثبت"
                    value={companyInfo.nationalIdOrRegNo}
                    valueDir="ltr"
                  />
                  <FieldRow
                    label="حوزه فعالیت (صنعت)"
                    value={companyInfo.industry}
                  />
                  <FieldRow
                    label="آدرس وب‌سایت شرکت"
                    value={companyInfo.website}
                    valueDir="ltr"
                  />
                  <FieldRow
                    label="اندازه شرکت"
                    value={companyInfo.companySize}
                  />
                </div>
              </div>

              <div className="w-full bg-garyLight rounded-2xl shadow p-6">
                <div className="flex flex-col">
                  <h3 className="t-purpleDark text-lg font-extrabold">
                    اطلاعات رابط یا نماینده (Contact Person)
                  </h3>
                  <p className="text-slate-500 text-xs mt-2 text-right leading-6">
                    کسی که قرار است پنل را مدیریت کند یا رابط فنی/مالی شرکت با شما
                    باشد.
                  </p>
                </div>

                <div className="mt-4 grid grid-cols-1 gap-3">
                  <FieldRow
                    label="نام و نام خانوادگی نماینده"
                    value={contactPerson.fullName}
                  />
                  <FieldRow label="سمت شغلی" value={contactPerson.jobTitle} />
                  <FieldRow
                    label="ایمیل سازمانی (Business Email)"
                    value={contactPerson.businessEmail}
                    valueDir="ltr"
                  />
                  {/* <p className="text-slate-500 text-xs text-right leading-6">
                    پیشنهاد می‌شود ایمیل شرکتی مثل name@company.com ثبت شود (نه
                    جیمیل یا یاهو).
                  </p> */}
                  <FieldRow
                    label="شماره موبایل مستقیم"
                    value={contactPerson.mobile}
                    valueDir="ltr"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showLogOut && <BrandLogOutBox closeModal={setShowLogOut} />}
    </>
  );
}

export default BrandingPage;

